import { extractActiveItemMetadata } from '@wix/a11y-wizard-common';
import { getSiteStructure } from '@wix/ambassador-viewer-structure-v1-site-structure-item/http';
import { PageSegment, SortOrder } from '@wix/ambassador-viewer-structure-v1-site-structure-item/types';
const MAX_LIMIT = 100;
export const fetchSiteStructure = async (httpClient, itemTypeConfig, errorHandler) => {
  const {
    siteStructureFilter
  } = itemTypeConfig;
  const {
    withErrorHandler
  } = errorHandler;
  return withErrorHandler(async () => {
    let cursor;
    const siteStructure = [];
    do {
      const {
        data: {
          pageData,
          results
        }
      } = await httpClient.request(getSiteStructure({
        filter: siteStructureFilter,
        pageVersion: PageSegment.SAVED,
        paging: {
          cursor,
          limit: MAX_LIMIT
        },
        sorting: {
          order: SortOrder.ASC
        }
      }));
      if (results != null && results.length) {
        const items = extractActiveItemMetadata(results);
        siteStructure.push(...items);
      }
      cursor = pageData == null ? void 0 : pageData.cursor;
    } while (cursor);
    return siteStructure;
  }, {
    errorCodesMap: {}
  });
};
//# sourceMappingURL=fetch-site-structure.js.map